import React from "react";
import { useCheckPermission } from "@shared/hooks";
import { Hospital } from "@shared/models";

export interface AccessControlProps {
  permission?: string;
  children?: React.ReactNode;
  option?: { onlyAppAdmin?: boolean; hospital?: Hospital | null };
}

const AccessControl = (props: AccessControlProps) => {
  const { permission, children, option } = props;

  const permitted = useCheckPermission(permission, option);

  return permitted ? <>{children}</> : null;
};

export default AccessControl;
